import React from 'react';
import autobind from "autobind-decorator";
import { connect } from "react-redux";

import { PureComponent } from 'core/components';
import { ViewProfilePage } from 'content/pages';
import { profile } from 'core/module/operations';
import services from 'core/services';

class ViewProfile extends PureComponent {
  componentDidMount() {
    const params = {
      store: 2,
      get_points: true
    };

    services.storage.get("customer_token") && this.props.profile(params);
  }

  render() {
    return (
      <ViewProfilePage
        navigate={this.$f7router}
      />
    )
  };
};

export default connect(
  state => ({
    authorized: state.General.authorized
  }),
  {
    profile
  }
)(autobind(ViewProfile));
